export const listingsState = {
    state: {}
}
